var kickstart = {
    slide2id: function(id) {
        jQuery("html, body").animate({scrollTop: jQuery(id).offset().top}, 200);
    },

    extend: function(extender) {
        jQuery.extend(kickstart, extender);
    },

    getParent: function(context, parentSelector, depth) {
        depth = (typeof depth !== 'undefined') ? depth : 5;
        var parent = jQuery(context).parent();
        if(typeof parent === 'undefined' || depth <= 0) {
            console.log('Was not able to select parent with selector "'+parentSelector+'".');
            return undefined;
        }

        if(jQuery(parent).is(parentSelector)) {
            return parent;
        }

        return kickstart.getParent(parent, parentSelector, depth -1);
    },

    readParentData: function(context, parentSelector, dataName, depth) {
        depth = (typeof depth !== 'undefined') ? depth : 5;
        var parent = kickstart.getParent(context, parentSelector, depth);
        if(typeof parent === 'undefined') {
            return undefined;
        }
        return parent.data(dataName);
    }
};

window.kickstartjs = kickstart;